import {classNames} from "shared/lib/classNames/classNames";
import cls from "./MissionPage.module.scss";
import Title, {TitleTheme} from "shared/ui/Title/Title";
import Paragraph from "shared/ui/Paragraph/Paragraph";
import MissionOffice from "shared/assets/images/missionOffice.png";
import {ReactComponent as Logo} from "shared/assets/icons/LigalTimesLogo.svg";


export const MissionPage = () => {
    return (
        <div id={"missionPage"} className={classNames(cls.MissionPage, {}, [])}>
            <section className={classNames("page-section", {}, [])}>
                <div className={classNames("container container__main")}>
                    <div className={cls.mission}>
                        <div className={cls.mission__text}>
                            <Title className={cls.mission__title} sentences={["Our Mission"]} colors={[TitleTheme.NEUTRAL]}/>
                            <Paragraph>
                                We aim to catalyze success for companies and entrepreneurs by materializing their innovative concepts through cutting-edge mobile solutions. Our goal is to expand the frontiers of mobile technology capabilities, developing applications that elevate quality of life, optimize operations, and unlock fresh prospects for our customers.                            </Paragraph>
                        </div>

                        <div className={cls.mission__image}>
                            <img src={MissionOffice} alt="mission"/>
                        </div>
                    </div>
                </div>
                {/*<div className={cls.logoDecoration}>*/}
                {/*    <Logo width={627} height={627} fill={"#F4F7FA"}/>*/}
                {/*</div>*/}
            </section>
        </div>
    )
};

